// extracted by mini-css-extract-plugin
module.exports = {"outer-wrapper":"app_outer-wrapper__MJqv6","div":"app_div__1dudq"};